import React from "react";
import JapanLanguagesCard from "./JapanLanguagesCard";

const JapanHero = ({ onBookDemo, onExploreCourses }) => {
  return (
    <section id="jl-hero" className="jl-hero">
      <div className="container">
        <div className="jl-hero__grid">
          <div className="jl-hero__content wow fadeInUp">
            <span className="jl-hero__badge">オンライン語学スクール</span>
            <h1 className="jl-hero__title">
              日本語も英会話も
              <span>オンラインで本気で学べる</span>
            </h1>
            <p className="jl-hero__subtitle">
              経験豊富な講師によるライブレッスンで、初心者から安心して学習できます。無料体験レッスン実施中。
            </p>
            <div className="jl-hero__ctas">
              <button type="button" className="jl-btn jl-btn--primary" onClick={onBookDemo}>
                無料体験レッスンを予約する
              </button>
              <button type="button" className="jl-btn jl-btn--secondary" onClick={onExploreCourses}>
                コースを見る
              </button>
            </div>
            <div className="jl-hero__trust">
              <div className="jl-hero__trust-item">
                <strong>500名以上</strong>
                <span>受講生</span>
              </div>
              <div className="jl-hero__trust-item">
                <strong>認定講師</strong>
                <span>指導</span>
              </div>
              <div className="jl-hero__trust-item">
                <strong>ライブ</strong>
                <span>オンライン授業</span>
              </div>
              <div className="jl-hero__trust-item">
                <strong>資格</strong>
                <span>対応コース</span>
              </div>
            </div>
          </div>

          <div className="jl-hero__visual wow fadeInUp" data-wow-delay="0.2s">
            <JapanLanguagesCard />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JapanHero;
